import { Dialog, DialogContent, DialogTitle, Stack } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { fetchImgs } from "../services/util";
import FormImage from "../form/FormImage";
import { IFormEvent } from "../form/Form.interface";
import { APIHOST } from "../services/api.service";

export default function SelectImgs(props: { id: string[], onClose: (url?: string) => void }) {
  const { id, onClose } = props
  const [imgs, setImgs] = useState<string[]>()

  function find() {
    axios.post('cms/newslistByids', { id }).then(({ data }) => {
      data.forEach((i: any) => {
        i.newimg = Array.from(new Set([i.newimg, ...fetchImgs(i.text)].filter(i => !!i)))
      });
      setImgs(Array.from(new Set(data.map((i: { newimg: any; }) => i.newimg).flat())))
    })
  }

  useEffect(find, [id])

  return <Dialog open={true} onClose={() => onClose()}>
    <DialogTitle>选取图片</DialogTitle>
    <DialogContent>
      <Stack direction={"row"} flexWrap={"wrap"} >
        {imgs?.map((i: string, index: number) => <Stack key={index} onClick={() => {
          onClose(i)
        }}>
          <img style={{ margin: '10px' }} src={i} width='100px' />
        </Stack>)}
        <FormImage name={"newimg"} value={undefined} label={""} onChange={(e) => {
          setImgs([...(imgs || []), `${APIHOST}/upload/${e.target.value}`])
        }} />
      </Stack>
    </DialogContent>
  </Dialog>

}